import React from "react"
import PropTypes from "prop-types"
import {Button, Card, Col, Form, Mention, Row} from "antd"

const FormItem = Form.Item;
//const Search = Input.Search;
const {toString, getMentions} = Mention;

class BrowseView extends React.Component {

    static propTypes = {
        masterTitle: PropTypes.node.isRequired,
        master: PropTypes.element.isRequired,
        detailTitle: PropTypes.node.isRequired,
        detail: PropTypes.element.isRequired,
        /*modal: PropTypes.element.isRequired,*/
        initialQuery: PropTypes.func.isRequired,
        searchableProps: PropTypes.array.isRequired,
        searchLogic: PropTypes.func.isRequired,
        loading: PropTypes.bool.isRequired,
        vertical: PropTypes.bool.isRequired
    };

    state = {
        suggestions: []
    };

    componentDidMount() {
        this.props.initialQuery();

    }

    onSearchChange = (value, trigger) => {
        //console.log('onSearchChange', value, trigger);
        this.setState({
            suggestions: this.props.searchableProps.filter(item => item.indexOf(value) !== -1),
        });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((errors, values) => {
            if (!errors) {
                const request = toString(values.search)
                    .split("@")
                    .map(part => part.trim())
                    .filter(part => part.length > 3 && part.indexOf(' ') > 0)
                    .reduce((acc, part) => {

                        const split = part.split(" ");
                        const key = split[0];
                        const value = part.replace(key, "").trim();
                        acc[key] = value;

                        return acc
                    }, {});
                this.props.searchLogic(request);


            }
        });
    };

    resetForm = (e) => {
        this.props.form.resetFields()
    };

    checkMention = (rule, value, callback) => {
        const {getFieldValue} = this.props.form;
        const searchState = getFieldValue('search');
        const search = toString(searchState);

        if (!search || search === '') {
            callback();
            return
        }
        const mentions = getMentions(searchState);
        if (mentions.length < 1) {
            callback(new Error('More than one property must be selected! (use @)'));
        } else {
            callback();
        }
    };

    render() {
        const {masterTitle, master, detailTitle, detail, form, loading, vertical, drawer1, drawer2} = this.props;
        const {getFieldDecorator} = form;
        return <div>
            <Card type='inner'>
                <Form onSubmit={this.handleSubmit} layout='horizontal'>
                    <Row gutter={25} className='browse-search'>
                        <Col span={18}>
                            <FormItem>
                                {getFieldDecorator('search', {
                                    rules: [{validator: this.checkMention}]
                                })(
                                    <Mention suggestions={this.state.suggestions} autoFocus={true}
                                             placeholder="Search: type @ to see available properties"
                                             onSearchChange={this.onSearchChange} onChange={this.onChange}
                                    />
                                )}
                            </FormItem>

                        </Col>

                        <Col span={2}>
                            <FormItem>
                                <Button icon="search" type="primary" htmlType="submit" loading={loading}
                                        onClick={this.handleSubmit}>
                                    Search
                                </Button>
                            </FormItem>
                        </Col>
                    </Row>
                </Form>
            </Card>


            {
                vertical ? (
                        <Row gutter={25} className='browse-search'>
                            <Col span={10}><Card title={masterTitle}>
                                {master}
                            </Card>
                            </Col>
                            <Col span={14}>
                                <Card title={detailTitle}>
                                    {detail}
                                </Card>

                            </Col>
                        </Row>
                    ) :
                    (
                        <div>
                            <Card title={masterTitle}>
                                {master}
                            </Card>
                            <Card title={detailTitle}>
                                {detail}
                            </Card>
                        </div>


                    )
            }

            {drawer1}
            {drawer2}

        </div>
    }
}

export default Form.create()(BrowseView)



// WEBPACK FOOTER //
// ./src/js/browse/BrowseView.js